import React from "react";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { CloudinaryImage } from "@comparaonline/cloudinary-image";

import { withStyles, Styles } from "./styles";

interface CarDealerSuccessProps {
  carDealerName: string;
}

const CarDealerSuccessBase: React.FC<CarDealerSuccessProps & Styles> = ({
  classes,
  carDealerName
}) => {
  const t = useFormatMessage();

  return (
    <div className={classes.container}>
      <CloudinaryImage className={classes.img} name="v1584642707/emails/icons/Start_stod75.svg" />
      <Typography className={classes.title} variant="h5">
        {t("carDealer.success.title")}
      </Typography>
      <Typography variant="body1" className={classes.subtitle}>
        {t("carDealer.success.subtitle")}
      </Typography>
      <Fab
        className={classes.back}
        href={`/seguro-automotriz/automotora/${carDealerName}`}
        variant="extended"
      >
        {t("carDealer.success.back")}
      </Fab>
    </div>
  );
};

const CarDealerSuccess = withStyles(CarDealerSuccessBase);

export { CarDealerSuccess };
